import {
  Avatar,
  Badge,
  Group,
  Paper,
  ScrollArea,
  Stack,
  Text,
} from "@mantine/core";
import dayjs from "dayjs";

const ScanRow = ({ scan, onClick }) => (
  <Paper
    withBorder
    p="sm"
    radius="md"
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <Group justify="space-between" wrap="nowrap">
      <Group wrap="nowrap" gap="sm" style={{ minWidth: 0 }}>
        <Avatar
          src={scan.picture}
          radius="xl"
          color="initials"
          name={`${scan.firstName || ""} ${scan.lastName || ""}`}
        />
        <Stack gap={0} style={{ minWidth: 0 }}>
          <Group gap="xs" wrap="nowrap">
            <Text fw={600} truncate>
              {scan.firstName} {scan.lastName}
            </Text>
            {scan.scanCount > 1 && (
              <Badge size="sm" variant="light" color="blue">
                x{scan.scanCount}
              </Badge>
            )}
          </Group>
          <Text size="sm" c="dimmed" truncate>
            {scan.email}
          </Text>
        </Stack>
      </Group>

      <Stack gap={0} align="flex-end" style={{ flexShrink: 0 }}>
        <Text size="xs" c="dimmed">
          {dayjs(scan.lastScannedAt).format("HH:mm:ss")}
        </Text>
        <Text size="xs" c="dimmed">
          #{scan.ticketId}
        </Text>
      </Stack>
    </Group>
  </Paper>
);

const RecentScans = ({ scans, onScanClick }) => {
  return (
    <Stack gap="sm" w="100%" maw={520}>
      <Group gap="xs">
        <Text fw={600}>Recent scans</Text>
        {scans?.length > 0 && (
          <Text size="sm" c="dimmed">
            ({scans.length})
          </Text>
        )}
      </Group>

      {!scans?.length ? (
        <Text c="dimmed" size="sm" ta="center" py="md">
          No scans yet. Scanned attendees will appear here.
        </Text>
      ) : (
        <ScrollArea.Autosize mah={440} type="auto">
          <Stack gap="xs" pr="xs">
            {scans.map((scan) => (
              <ScanRow
                key={`${scan.ticketId}-${scan.lastScannedAt}`}
                scan={scan}
                onClick={() => onScanClick(scan.ticketId)}
              />
            ))}
          </Stack>
        </ScrollArea.Autosize>
      )}
    </Stack>
  );
};

export default RecentScans;
